import Vue from 'vue'
import VueResource from 'vue-resource'
import Multiselect from '../../component/multiselect.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import datePicker from '../../component/datePicker.vue'
import checkbox from '../../component/dccore-form/checkbox.vue'
import moment from 'moment'
import 'moment/locale/pl'
import Singleselect from '../../component/simple-form/singleselect.vue'
import TakeModal from './warehouse_warehouseman_take.vue'
import UpdateModal from './warehouse_warehouseman_update.vue'
import PrepareModal from './warehouse_warehouseman_prepare.vue'
import MoveModal from './warehouse_warehouseman_move.vue'
import MoveMaterialsModal from './warehouse_warehouseman_move_materials.vue'
import ReturnModal from './warehouse_warehouseman_return.vue'
import store from '../../store/warehouseman'
import * as toastr from 'toastr'

require('bootstrap')

if ($('#warehouse_warehouseman').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#warehouse_warehouseman',
    store,
    components: {
      RingLoader,
      datePicker,
      Multiselect,
      checkbox,
      Singleselect,
      TakeModal,
      PrepareModal,
      MoveModal,
      MoveMaterialsModal,
      ReturnModal,
      UpdateModal
    },
    mixins: [mixins],
    data: {
      loading: 0,
      searchForm: {
        data: {
          date: moment().locale('pl').format('YYYY-MM-DD'),
          movementUser: 'all',
          movementType: null,
          warehouse: null,
        },
        options: {
          formHash: null,
          movementsUsersWithShowAll: ['all', 'me'],
          movementsUsersWithoutShowAll: ['me'],
          movementTypes: [],
        }
      },
      takeItems: [],
      takeModal: false,
    },
    computed: {
      date: function () {
        return this.searchForm.date
      },
      warehouses() {
        let emptyWarehouse = [{
          'id' : null,
          'name' : Translator.trans('warehouseman.main.search.movement_users.all'),
          'symbol' : 'ALL'
        }]

        return emptyWarehouse.concat(this.$store.state.warehouses)
      },
    },
    watch: {
      date: function () {
        //this.search();
      },
    },
    mounted: function () {
      this.loading++
      if ($('#form_hash').length) {
        this.formHash = $('#form_hash').val()
      }
      this.getMovementTypes()
      this.$store.dispatch('fetchWarehouses')

      this.search()
      this.loading--
    },
    methods: {
      search() {
        window[`${this.formHash}_submitForm`](new Event(''))
      },
      getMovementTypes() {
        let url = Routing.generate('api_get_warehouse_shifts_all_movement_type')
        this.loading++
        this.$http.get(url).then(response => {
          this.searchForm.options.movementTypes = this.searchForm.options.movementTypes.concat(response.data)
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      openPrepareModal() {
        this.popupOpen()
        this.$refs.prepareModal.init(
          this.getSelectedGridItems()
            .map((item) => {
              return {
                id: $(item).data('id'),
                status: $(item).data('status'),
              }
            })
        )
          .then(() => {

            this.search()
          })
          .finally(() => {
            this.popupClose()
          })
      },
      openTakeModal() {
        this.popupOpen()

        this.$refs.takeModal.init(
          this.getSelectedGridItems()
            .map((item) => {
              return {
                id: $(item).data('id'),
                status: $(item).data('status'),
                moveType: $(item).data('movement-type'),
              }
            })
        ).catch(() => {
          toastr.error(Translator.trans('global.messages.fetch_problem'))
        }).then(() => {
          this.search()
        }).finally(() => {
          this.popupClose()
        })
      },
      openMoveModal() {
        this.popupOpen()
        this.$refs.moveModal.init(
          this.getSelectedGridItems()
            .map((item) => {
              return {
                id: $(item).data('id'),
                status: $(item).data('status'),
                moveType: $(item).data('movement-type'),
              }
            })
        ).then(() => {
          this.search()
        }).catch(() => {
          toastr.error(Translator.trans('global.messages.fetch_problem'))
        }).finally(() => {
          this.popupClose()
        })
      },
      openMoveMaterialsModal() {
        this.popupOpen()
        this.$refs.moveMaterialsModal.init(
          this.getSelectedGridItems()
            .map((item) => {
              return {
                id: $(item).data('id'),
                status: $(item).data('status'),
                moveType: $(item).data('movement-type'),
              }
            })
        ).then(() => {
          this.search()
        }).catch(() => {
          toastr.error(Translator.trans('global.messages.fetch_problem'))
        }).finally(() => {
          this.popupClose()
        })
      },
      openReturnModal() {
        this.popupOpen()
        this.$refs.returnModal.init()
          .then(() => {
            this.search()
          })
          .finally(() => {
            this.popupClose()
          })
      },
      openUpdateModal() {
        this.popupOpen()
        this.$refs.updateModal.init(
          this.getSelectedGridItems()
            .map((item) => {
              return {
                id: $(item).data('id'),
                status: $(item).data('status'),
                moveType: $(item).data('movement-type'),
              }
            })
        ).then(() => {
          this.search()
        }).catch(() => {
          toastr.error(Translator.trans('global.messages.fetch_problem'))
        }).finally(() => {
          this.popupClose()
        })
      },
      popupOpen() {
        $('.portlet-body, .portlet-title', '#warehouse_warehouseman').addClass('hidden-print')
      },
      popupClose() {
        $('.portlet-body, .portlet-title', '#warehouse_warehouseman').removeClass('hidden-print')
      },
      getSelectedGridItems() {
        let selected = []
        $('.action').each((index, item) => {
          if ($(item).is(':checked')) {
            selected.push($(item).closest('tr'))
          }
        })
        return selected
      },
      getUsers() {
        this.loading++

      },
      translateMovementUser(name) {
        return Translator.trans(`warehouseman.main.search.movement_users.${name}`)
      },
      translateMovementType(name) {
        return name === 'all' ?
          Translator.trans('warehouseman.main.search.movement_users.all') :
          Translator.trans(`warehouse_shift.entity.movement_types.${name}`)
      },
      isGranted() {
        return Object.values(window.appValues.warehouse.permissions).indexOf('WAREHOUSE_WAREHOUSEMAN_UPDATE') !== -1
      },
    }
  })
}
